module.exports = __webpack_public_path__ + "static/img/m.gif";